import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

Vue.use(Vuex)

const state = {
  chosenPrice: {
    id: undefined,
    title: undefined,
    amount: undefined
  },
  chosenWork: {
    id: undefined,
    title: undefined
  },
  chosenStop: {
    parentID: undefined,
    id: undefined,
    title: undefined,
    length: undefined,
    remark: undefined
  },
  chosenPipes: [],
  sponsorship: {
    sponsor: {
      id: undefined,
      fullname: undefined,
      giftedToName: undefined,
      allowPublication: false,
      street: undefined,
      postalCode: undefined,
      city: undefined
    },
    pipes: [{
      id: undefined,
      tone: undefined,
      register: undefined,
      price: {
        title: undefined,
        amount: undefined
      }
    }],
    grandTotal: undefined
  }
}

const store = new Vuex.Store({
  state,
  getters: {
    chosenPrice: (state) => {
      return state.chosenPrice
    },
    chosenWork: (state) => {
      return state.chosenWork
    },
    chosenStop: (state) => {
      return state.chosenStop
    },
    chosenPipes: (state) => {
      return state.chosenPipes
    },
    sponsorship: (state) => {
      return state.sponsorship
    }
  },
  actions: {
    setPrice (context, chosenPrice) {
      // console.info('price action')
      context.commit('setPrice', chosenPrice)
    },
    setWork (context, chosenWork) {
      // console.info('work action')
      context.commit('setWork', chosenWork)
    },
    setStop (context, chosenStop) {
      // console.info('stop action')
      context.commit('setStop', chosenStop)
    },
    selectPipe (context, pipe) {
      // console.info('select pipe action')
      context.commit('selectPipe', pipe)
    },
    removePipe (context, pipe) {
      // console.info('remove pipe action')
      context.commit('removePipe', pipe)
    },
    updateSponsorship (context, payload) {
      // console.info('update sponsorship action')
      context.commit('updateSponsorship', payload)
    }
  },
  mutations: {
    setPrice (state, chosenPrice) {
      if (typeof window !== 'undefined') {
        // für Server seitiges JavaScript ohne 'window' Object
      }
      // console.info('price mutation')
      state.chosenPrice = chosenPrice
    },
    setWork (state, chosenWork) {
      if (typeof window !== 'undefined') {
        // für Server seitiges JavaScript ohne 'window' Object
      }
      // console.info('work mutation')
      state.chosenWork = chosenWork
    },
    setStop (state, chosenStop) {
      if (typeof window !== 'undefined') {
        // für Server seitiges JavaScript ohne 'window' Object
      }
      // console.info('stop mutation')
      state.chosenStop = chosenStop
    },
    selectPipe (state, pipe) {
      if (typeof window !== 'undefined') {
        // für Server seitiges JavaScript ohne 'window' Object
      }
      // console.info('select pipe mutation')
      state.chosenPipes.push(pipe)
    },
    removePipe (state, pipe) {
      if (typeof window !== 'undefined') {
        // für Server seitiges JavaScript ohne 'window' Object
      }
      // console.info('remove pipe mutation')
      state.chosenPipes = _.without(state.chosenPipes, pipe)
    },
    updateSponsorship (context, payload) {
      // console.info('update sponsorship mutation')
      // console.info(payload.action)
      // console.info(payload.pipe)

      switch (payload.action) {
        case 'addPipe':
          // prüfe, ob bereits eine Pfeife im Store ist
          if (typeof state.sponsorship.pipes[0].id === 'undefined') {
            state.sponsorship.pipes[0].id = payload.pipe.id
            state.sponsorship.pipes[0].tone = payload.pipe.tone
            state.sponsorship.pipes[0].register = payload.pipe.register
            state.sponsorship.pipes[0].price.title = payload.pipe.price.title
            state.sponsorship.pipes[0].price.amount = payload.pipe.price.amount
          } else {
            state.sponsorship.pipes.push(payload.pipe)
          }
          break
        case 'removePipe':
          let filteredPipes = _.filter(state.sponsorship.pipes, (object) => { return object.id !== payload.pipe.id })
          // ist dies die letzte Pfeife im Store?
          if (state.sponsorship.pipes.length === 1) {
            state.sponsorship.pipes[0].id = undefined
            state.sponsorship.pipes[0].tone = undefined
            state.sponsorship.pipes[0].register = undefined
            state.sponsorship.pipes[0].price.title = undefined
            state.sponsorship.pipes[0].price.amount = undefined
          } else {
            state.sponsorship.pipes = filteredPipes
          }
          break
        case 'updateSponsor':
          state.sponsorship.sponsor.id = payload.sponsor.id
          state.sponsorship.sponsor.fullname = payload.sponsor.fullname
          state.sponsorship.sponsor.giftedToName = payload.sponsor.giftedToName
          state.sponsorship.sponsor.street = payload.sponsor.street
          state.sponsorship.sponsor.postalCode = payload.sponsor.postalCode
          state.sponsorship.sponsor.city = payload.sponsor.city
          state.sponsorship.sponsor.allowPublication = payload.sponsor.allowPublication
          break
        case 'updateGrandTotal':
          state.sponsorship.grandTotal = payload.grandTotal
          break
        default:
          break
      }
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js